module.exports = __webpack_public_path__ + "img/greyfilledstar.fe508ad7.svg";